import styled from 'styled-components';

export const ProfileName = styled.div`
  font-size: 1.4rem;
  grid-area: name;
`;
